"use client";

import { createContext, type PropsWithChildren, use } from "react";
import type { GlobalData } from "./dal";

interface GlobalDataContext {
  data: GlobalData;
  preview: boolean;
}

export const GlobalContext = createContext<GlobalDataContext>(null!);

export const GlobalProvider = ({
  children,
  data,
  preview,
}: PropsWithChildren<{
  data: GlobalDataContext["data"];
  preview: GlobalDataContext["preview"];
}>) => {
  return (
    <GlobalContext.Provider
      value={{
        data,
        preview,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => {
  const ctx = use(GlobalContext);
  if (!ctx) {
    throw new Error("useGlobal must be used within a GlobalProvider");
  }
  return ctx;
};
